webpackJsonp([217596727120640],{

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(105);
	var Stylis = _interopDefault(__webpack_require__(286));
	__webpack_require__(199);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses && cache.compat !== true) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(90));
	var React = __webpack_require__(1);
	var createCache = _interopDefault(__webpack_require__(194));
	var utils = __webpack_require__(107);
	var serialize = __webpack_require__(64);
	var sheet = __webpack_require__(105);
	var css = _interopDefault(__webpack_require__(196));
	
	var EmotionCacheContext = React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache() : null);
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/^.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(64);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(284));
	var unitless = _interopDefault(__webpack_require__(287));
	var memoize = _interopDefault(__webpack_require__(197));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var isProcessableValue = function isProcessableValue(value) {
	  return value != null && typeof value !== 'boolean';
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles + ";";
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        break;
	      }
	
	    case 'string':
	      if (false) {
	        var matched = [];
	        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
	          var fakeVarName = "animation" + matched.length;
	          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
	          return "${" + fakeVarName + "}";
	        });
	
	        if (matched.length) {
	          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
	        }
	      }
	
	      break;
	  } // finalize string values (regular strings and functions interpolated into css calls)
	
	
	  if (registered == null) {
	    return interpolation;
	  }
	
	  var cached = registered[interpolation];
	
	  if (false) {
	    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	    shouldWarnAboutInterpolatingClassNameFromCss = false;
	  }
	
	  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else if (isProcessableValue(value)) {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            if (isProcessableValue(value[_i])) {
	              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	            }
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                if (false) {
	                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
	                }
	
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor,
	      toString: function toString() {
	        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
	      }
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _defineProperty = _interopDefault(__webpack_require__(89));
	var React = __webpack_require__(1);
	var isPropValid = _interopDefault(__webpack_require__(285));
	var core = __webpack_require__(195);
	var utils = __webpack_require__(107);
	var serialize = __webpack_require__(64);
	
	var testOmitPropsOnStringTag = isPropValid;
	
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	
	var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
	  return typeof tag === 'string' && // 96 is one less than the char code
	  // for "a" so this is checking that
	  // it's a lowercase character
	  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	};
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	
	var createStyled = function createStyled(tag, options) {
	  if (false) {
	    if (tag === undefined) {
	      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	    }
	  }
	
	  var identifierName;
	  var shouldForwardProp;
	  var targetClassName;
	
	  if (options !== undefined) {
	    identifierName = options.label;
	    targetClassName = options.target;
	    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
	      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
	      options.shouldForwardProp(propName);
	    } : options.shouldForwardProp;
	  }
	
	  var isReal = tag.__emotion_real === tag;
	  var baseTag = isReal && tag.__emotion_base || tag;
	
	  if (typeof shouldForwardProp !== 'function' && isReal) {
	    shouldForwardProp = tag.__emotion_forwardProp;
	  }
	
	  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
	  var shouldUseAs = !defaultShouldForwardProp('as');
	  return function () {
	    var args = arguments;
	    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
	
	    if (identifierName !== undefined) {
	      styles.push("label:" + identifierName + ";");
	    }
	
	    if (args[0] == null || args[0].raw === undefined) {
	      styles.push.apply(styles, args);
	    } else {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles.push(args[0][0]);
	      var len = args.length;
	      var i = 1;
	
	      for (; i < len; i++) {
	        if (false) {
	          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	        }
	
	        styles.push(args[i], args[0][i]);
	      }
	    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
	
	
	    var Styled = core.withEmotionCache(function (props, context, ref) {
	      return React.createElement(core.ThemeContext.Consumer, null, function (theme) {
	        var finalTag = shouldUseAs && props.as || baseTag;
	        var className = '';
	        var classInterpolations = [];
	        var mergedProps = props;
	
	        if (props.theme == null) {
	          mergedProps = {};
	
	          for (var key in props) {
	            mergedProps[key] = props[key];
	          }
	
	          mergedProps.theme = theme;
	        }
	
	        if (typeof props.className === 'string') {
	          className = utils.getRegisteredStyles(context.registered, classInterpolations, props.className);
	        } else if (props.className != null) {
	          className = props.className + " ";
	        }
	
	        var serialized = serialize.serializeStyles(styles.concat(classInterpolations), context.registered, mergedProps);
	        var rules = utils.insertStyles(context, serialized, typeof finalTag === 'string');
	        className += context.key + "-" + serialized.name;
	
	        if (targetClassName !== undefined) {
	          className += " " + targetClassName;
	        }
	
	        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
	        var newProps = {};
	
	        for (var _key in props) {
	          if (shouldUseAs && _key === 'as') continue;
	
	          if ( // $FlowFixMe
	          finalShouldForwardProp(_key)) {
	            newProps[_key] = props[_key];
	          }
	        }
	
	        newProps.className = className;
	        newProps.ref = ref || props.innerRef;
	
	        if (false) {
	          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
	        }
	
	        var ele = React.createElement(finalTag, newProps);
	
	        return ele;
	      });
	    });
	    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	    Styled.defaultProps = tag.defaultProps;
	    Styled.__emotion_real = Styled;
	    Styled.__emotion_base = baseTag;
	    Styled.__emotion_styles = styles;
	    Styled.__emotion_forwardProp = shouldForwardProp;
	    Object.defineProperty(Styled, 'toString', {
	      value: function value() {
	        if (targetClassName === undefined && ("production") !== 'production') {
	          return 'NO_COMPONENT_SELECTOR';
	        } // $FlowFixMe: coerce undefined to string
	
	
	        return "." + targetClassName;
	      }
	    });
	
	    Styled.withComponent = function (nextTag, nextOptions) {
	      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
	    };
	
	    return Styled;
	  };
	};
	
	exports.default = createStyled;


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var styled = _interopDefault(__webpack_require__(198));
	
	var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	var newStyled = styled.bind();
	tags.forEach(function (tagName) {
	  newStyled[tagName] = newStyled(tagName);
	});
	
	exports.default = newStyled;


/***/ }),

/***/ 107:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ }),

/***/ 2355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(841);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component) {
	      _inherits(LazyLoadDecorated, _Component);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _index2.default,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(2357);
	
	var _scrollParent = __webpack_require__(2358);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(2356);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(2359);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _decorator = __webpack_require__(2355);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentHeight = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentHeight = _parent$getBoundingCl.height;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var height = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    height = _node$getBoundingClie.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    height = defaultBoundingClientRect.height;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!node) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof process !== 'undefined' && ("production") !== 'production') {
	        if (_react2.default.Children.count(this.props.children) > 1) {
	          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
	        }
	
	        if (this.props.wheel) {
	          // eslint-disable-line
	          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
	        }
	
	        // Warn the user if placeholder and height is not specified and the rendered height is 0
	        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
	          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
	        }
	      }
	
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var needResetFinalLazyLoadHandler = false;
	      if (this.props.debounce !== undefined && delayType === 'throttle') {
	        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
	        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      }
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0) {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var lazyload = exports.lazyload = _decorator2.default;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(189)))

/***/ }),

/***/ 2356:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ }),

/***/ 2357:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ }),

/***/ 2358:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!node) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ }),

/***/ 2359:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(50);
	
	var _FeatureUtils = __webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeatureToggle = function (_Component) {
	  _inherits(FeatureToggle, _Component);
	
	  function FeatureToggle() {
	    _classCallCheck(this, FeatureToggle);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FeatureToggle.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        feature = _props.feature,
	        redirectTo = _props.redirectTo;
	
	    return (0, _FeatureUtils.isFeatureEnabled)(feature) === true ? children : _react2.default.createElement(_reactRouterDom.Redirect, { to: redirectTo });
	  };
	
	  return FeatureToggle;
	}(_react.Component);
	
	FeatureToggle.defaultProps = {
	  redirectTo: '/404'
	};
	
	exports.default = FeatureToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactResponsive = __webpack_require__(165);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _DateUtils = __webpack_require__(176);
	
	var _styledComponents = __webpack_require__(1266);
	
	__webpack_require__(1889);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsCard = function (_React$Component) {
	  _inherits(NewsCard, _React$Component);
	
	  function NewsCard() {
	    _classCallCheck(this, NewsCard);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NewsCard.prototype.render = function render() {
	    var _props = this.props,
	        news = _props.news,
	        readFullStoryText = _props.readFullStoryText,
	        watchVideoText = _props.watchVideoText;
	    var id = news.id,
	        imageUrl = news.imageUrl,
	        altText = news.altText,
	        mobileImageurl = news.mobileImageurl,
	        title = news.title,
	        date = news.date,
	        description = news.description,
	        newsUrl = news.newsUrl,
	        isVideo = news.isVideo,
	        leftColor = news.leftColor,
	        rightColor = news.rightColor;
	
	    var articleFormattedDate = (0, _DateUtils.getArticleFormattedDateTime)(date);
	    var idForimageAndReadArticle = altText.split('-').join('').split(/\s+/).join('-');
	    var clampClass = 'line-clamp line-clamp-3';
	    if (!imageUrl) {
	      clampClass = 'line-clamp line-clamp-6';
	    }
	    return React.createElement(
	      _styledComponents.NewsContainer,
	      { imageUrl: imageUrl, mobileImageurl: mobileImageurl },
	      React.createElement(
	        _reactResponsive2.default,
	        { query: '(min-device-width: 768px)' },
	        imageUrl ? React.createElement(
	          _styledComponents.NewsImageHolder,
	          {
	            id: id + 'Image',
	            leftColor: leftColor,
	            rightColor: rightColor,
	            href: newsUrl,
	            target: '_blank',
	            rel: 'noopener'
	          },
	          React.createElement(_styledComponents.NewsImage, {
	            dataSrc: imageUrl,
	            alt: altText,
	            draggable: false,
	            className: 'lazyload'
	          })
	        ) : null
	      ),
	      React.createElement(
	        _reactResponsive2.default,
	        { query: '(max-device-width: 767px)' },
	        mobileImageurl ? React.createElement(
	          _styledComponents.NewsImageHolder,
	          {
	            id: id + 'Image',
	            leftColor: leftColor,
	            rightColor: rightColor,
	            href: newsUrl
	          },
	          React.createElement(_styledComponents.NewsImage, {
	            dataSrc: mobileImageurl,
	            alt: altText,
	            draggable: false,
	            className: 'lazyload'
	          })
	        ) : null
	      ),
	      React.createElement(
	        _styledComponents.NewsDescriptionHolder,
	        {
	          imageUrl: imageUrl,
	          mobileImageurl: mobileImageurl,
	          description: description
	        },
	        React.createElement(_styledComponents.NewsTitle, {
	          dangerouslySetInnerHTML: {
	            __html: title
	          },
	          as: 'article'
	        }),
	        React.createElement(
	          _styledComponents.NewsDate,
	          { as: 'article' },
	          articleFormattedDate
	        ),
	        React.createElement(
	          _reactResponsive2.default,
	          { query: '(min-device-width: 768px)' },
	          description ? React.createElement(
	            _styledComponents.NewsDescription,
	            { className: clampClass, as: 'article' },
	            description
	          ) : null,
	          newsUrl ? React.createElement(
	            _styledComponents.LinkHolder,
	            null,
	            React.createElement(
	              _styledComponents.ReadFullStory,
	              {
	                href: newsUrl,
	                target: '_blank',
	                rel: 'noopener',
	                as: 'a'
	              },
	              isVideo ? React.createElement(
	                _styledComponents.LinkHolderText,
	                { id: id + 'Video' },
	                watchVideoText
	              ) : React.createElement(
	                _styledComponents.LinkHolderText,
	                { id: id + 'ReadStory' },
	                readFullStoryText
	              )
	            )
	          ) : null
	        )
	      )
	    );
	  };
	
	  return NewsCard;
	}(React.Component);
	
	exports.default = NewsCard;
	module.exports = exports['default'];

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NewsContainer = exports.NewsImageHolder = exports.NewsDescriptionHolder = exports.NewsDefaultImage = exports.NewsImage = exports.NewsDescription = exports.LinkHolder = exports.LinkHolderText = exports.ReadFullStory = exports.NewsDate = exports.NewsTitle = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	var _styledComponents = __webpack_require__(696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 
	 * @author: Chinmaya
	 */
	// https://codepen.io/siiron/pen/jfBhy/
	
	/* eslint-disable no-confusing-arrow, indent */
	
	var NewsTitle = /*#__PURE__*/exports.NewsTitle = (0, _reactEmotion2.default)(_Din.Typo18DarkGreyBlueThreeDDI, {
	  target: 'eb9t7bz0'
	})('margin-bottom:0.25em;text-align:left;letter-spacing:normal;', _mixins.mobile, '{font-size:1.286em;margin-bottom:0.286em;}');
	var NewsDate = /*#__PURE__*/exports.NewsDate = (0, _reactEmotion2.default)(_Din.Typo12DarkGreyBlueThreeDR, {
	  target: 'eb9t7bz1'
	})('margin-bottom:0.25em;text-align:left;letter-spacing:normal;', _mixins.mobile, '{margin-bottom:0.429em;font-size:0.929em;}');
	var ReadFullStory = /*#__PURE__*/exports.ReadFullStory = (0, _reactEmotion2.default)(_Din.Typo14PumpkinOrangeDB, {
	  target: 'eb9t7bz2'
	})('margin-bottom:0.375em;text-align:left;text-transform:uppercase;&:hover{color:', _Colors2.default.pumpkinOrange, ';text-decoration:none;outline:none;}&:focus{color:', _Colors2.default.pumpkinOrange, ';text-decoration:none;outline:none;}&:active{color:', _Colors2.default.pumpkinOrange, ';text-decoration:none;outline:none;}', _mixins.mobile, '{font-size:1em;margin-bottom:2.143em;}line-height:normal;letter-spacing:normal;');
	
	var LinkHolderText = /*#__PURE__*/exports.LinkHolderText = (0, _reactEmotion2.default)('span', {
	  target: 'eb9t7bz3'
	})();
	
	var LinkHolder = /*#__PURE__*/exports.LinkHolder = (0, _reactEmotion2.default)('article', {
	  target: 'eb9t7bz4'
	})();
	
	var NewsDescription = /*#__PURE__*/exports.NewsDescription = (0, _reactEmotion2.default)(_Din.Typo14BlueGreyTwoDR, {
	  target: 'eb9t7bz5'
	})('overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;margin-bottom:0.375em;text-align:left;letter-spacing:normal;', _mixins.mobile, '{font-size:1em;margin-bottom:0.429em;}');
	
	var NewsImage = /*#__PURE__*/exports.NewsImage = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'eb9t7bz6'
	})('width:100%;height:11.188em;object-fit:contain;user-drag:none;user-select:none;-moz-user-select:none;-webkit-user-drag:none;-webkit-user-select:none;-ms-user-select:none;', _mixins.mobile, '{object-fit:fill;}@media (min-height:320px) and (max-width:426px){height:auto;}');
	var NewsDefaultImage = /*#__PURE__*/exports.NewsDefaultImage = (0, _reactEmotion2.default)('div', {
	  target: 'eb9t7bz7'
	})('width:100%;height:8.188em;border-radius:0.125em;background-color:#f1f8ff;margin-bottom:0.75em;display:flex;align-items:center;justify-content:center;');
	
	var NewsDescriptionHolder = /*#__PURE__*/exports.NewsDescriptionHolder = (0, _reactEmotion2.default)('div', {
	  target: 'eb9t7bz8'
	})('margin:', function (props) {
	  return props.imageUrl ? '0em 0.375em' : '0em';
	}, ';box-shadow:', function (props) {
	  return props.imageUrl ? undefined : '0 0.0625em 0.125em 0 rgba(0, 79, 192, 0.3)';
	}, ';margin-top:', function (props) {
	  return props.imageUrl ? '0.75em' : '1.375em';
	}, ';padding:', function (props) {
	  return props.imageUrl ? '0' : '1.25em';
	}, ';display:flex;flex-direction:column;', _mixins.notMobile, '{max-height:11em;justify-content:', function (props) {
	  return props.description !== null ? 'space-between' : 'flex-start';
	}, ';}', _mixins.mobile, '{box-shadow:', function (props) {
	  return props.mobileImageurl ? undefined : '0 0.0625em 0.125em 0 rgba(0, 79, 192, 0.3)';
	}, ';padding:', function (props) {
	  return props.mobileImageurl ? '0' : '1.25em';
	}, ';}');
	var NewsImageHolder = /*#__PURE__*/exports.NewsImageHolder = (0, _reactEmotion2.default)('a', {
	  target: 'eb9t7bz9'
	})('border-radius:0.25em;width:100%;object-fit:contain;max-height:11.25em;overflow:hidden;');
	
	var NewsContainer = /*#__PURE__*/exports.NewsContainer = (0, _reactEmotion2.default)(_styledComponents.NewsSectionContainer, {
	  target: 'eb9t7bz10'
	})('font-size:1em;width:21.25em;margin-bottom:2.5em;@media (min-width:320px) and (max-width:426px){margin-bottom:2.143em;width:90%;}@media (min-width:427px) and (max-width:767px){margin-bottom:2.143em;width:18.75em;}');

/***/ }),

/***/ 1889:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(102);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactLazyload = __webpack_require__(841);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _styledComponents = __webpack_require__(1268);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Vamsi Tallam
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// NOTE: we are using react-lazy-load to fix the slick stacking of images issue
	
	var NewsLogos = function (_Component) {
	  _inherits(NewsLogos, _Component);
	
	  function NewsLogos() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NewsLogos);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.logoCollection = function (newsLogosList) {
	      var slickArray = [];
	      var index = void 0;
	      var logosList = void 0;
	      var logosPerSlide = 6;
	      for (index = 0; index < newsLogosList.length; index += logosPerSlide) {
	        logosList = newsLogosList.slice(index, index + logosPerSlide);
	        slickArray.push(logosList);
	      }
	      return slickArray;
	    }, _this.renderLogo = function (logo) {
	      var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var logoUrl = logo.logoUrl,
	          imageUrl = logo.imageUrl,
	          altText = logo.altText,
	          mobileHeight = logo.mobileHeight,
	          height = logo.height;
	
	      var logoId = altText.split(' ').join('-');
	      return _react2.default.createElement(
	        _styledComponents.LogoLink,
	        { id: logoId, href: logoUrl, target: '_blank' },
	        _react2.default.createElement(_styledComponents.Logo, {
	          src: imageUrl,
	          alt: altText,
	          height: isMobile ? mobileHeight : height
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  NewsLogos.prototype.render = function render() {
	    var _this2 = this;
	
	    var newsLogosList = this.props.newsLogosList;
	
	    var settings = {
	      dots: true,
	      speed: 500,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      arrows: false
	    };
	    return _react2.default.createElement(
	      _styledComponents.MediaContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.LogoContainer,
	        null,
	        newsLogosList.map(function (logo) {
	          return _this2.renderLogo(logo);
	        })
	      ),
	      _react2.default.createElement(
	        _reactLazyload2.default,
	        null,
	        _react2.default.createElement(
	          _styledComponents.LogoContainerMobile,
	          null,
	          _react2.default.createElement(
	            _reactSlick2.default,
	            settings,
	            this.logoCollection(newsLogosList).map(function (newsLogoList) {
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _styledComponents.SlickInnerDiv,
	                  null,
	                  newsLogoList.map(function (logo) {
	                    return _this2.renderLogo(logo, true);
	                  })
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return NewsLogos;
	}(_react.Component);
	
	exports.default = NewsLogos;
	module.exports = exports['default'];

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SlickInnerDiv = exports.LogoLink = exports.Logo = exports.LogoContainerMobile = exports.LogoContainer = exports.MediaContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _CloudinaryS3Image = __webpack_require__(23);
	
	var _CloudinaryS3Image2 = _interopRequireDefault(_CloudinaryS3Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaContainer = /*#__PURE__*/exports.MediaContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1m3s7kb0'
	})(); /**
	       * 
	       * @author: Vamsi Tallam
	       */
	
	var LogoContainer = /*#__PURE__*/exports.LogoContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1m3s7kb1'
	})('display:flex;flex-direction:row;justify-content:center;width:90%;margin:auto;align-items:center;flex-wrap:wrap;max-width:90em;margin-top:40px;', _mixins.mobile, '{display:none;}');
	
	var LogoContainerMobile = /*#__PURE__*/exports.LogoContainerMobile = (0, _reactEmotion2.default)('div', {
	  target: 'e1m3s7kb2'
	})(_mixins.notMobile, '{display:none;}margin-bottom:3.571em;');
	
	var Logo = /*#__PURE__*/exports.Logo = (0, _reactEmotion2.default)(_CloudinaryS3Image2.default, {
	  target: 'e1m3s7kb3'
	})(_mixins.mobile, '{display:flex;justify-content:center;align-items:center;}');
	var LogoLink = /*#__PURE__*/exports.LogoLink = (0, _reactEmotion2.default)('a', {
	  target: 'e1m3s7kb4'
	})('display:flex;justify-content:center;align-items:center;margin-left:1.25em;margin-right:1.25em;margin-bottom:2.813em;', _mixins.mobile, '{margin:1.071em;}');
	
	var SlickInnerDiv = /*#__PURE__*/exports.SlickInnerDiv = (0, _reactEmotion2.default)('div', {
	  target: 'e1m3s7kb5'
	})('display:flex;flex-wrap:wrap;align-items:center;justify-content:center;');

/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1270);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatsContainer = function (_Component) {
	  _inherits(StatsContainer, _Component);
	
	  function StatsContainer() {
	    _classCallCheck(this, StatsContainer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StatsContainer.prototype.render = function render() {
	    var _props$statsData$ = this.props.statsData[0],
	        articlesCount = _props$statsData$.articlesCount,
	        articlesText = _props$statsData$.articlesText,
	        mediaHousesCount = _props$statsData$.mediaHousesCount,
	        mediaHousesText = _props$statsData$.mediaHousesText;
	
	    return _react2.default.createElement(
	      _styledComponents.Container,
	      null,
	      _react2.default.createElement(
	        _styledComponents.ArticlesWrapper,
	        null,
	        _react2.default.createElement(
	          _styledComponents.ArticlesCount,
	          { as: 'p' },
	          articlesCount
	        ),
	        _react2.default.createElement(
	          _styledComponents.ArticlesText,
	          null,
	          articlesText
	        )
	      ),
	      _react2.default.createElement(
	        _styledComponents.MediaHousesWrapper,
	        null,
	        _react2.default.createElement(
	          _styledComponents.MediaHousesCount,
	          null,
	          mediaHousesCount
	        ),
	        _react2.default.createElement(
	          _styledComponents.MediaHousesText,
	          null,
	          mediaHousesText
	        )
	      )
	    );
	  };
	
	  return StatsContainer;
	}(_react.Component);
	
	exports.default = StatsContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MediaHousesText = exports.MediaHousesCount = exports.ArticlesText = exports.ArticlesCount = exports.MediaHousesWrapper = exports.ArticlesWrapper = exports.Container = undefined;
	
	var _styled = __webpack_require__(106);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = /*#__PURE__*/exports.Container = (0, _styled2.default)('div', {
	  target: 'e1z4f7t0'
	})('display:flex;flex-direction:row;justify-content:center;align-items:center;margin-top:40px;', (0, _mixins.maxDeviceWidth)(1023), '{margin-top:20px;}', (0, _mixins.maxDeviceWidth)(768), '{margin-top:20px;margin-bottom:20px;}');
	var ArticlesWrapper = /*#__PURE__*/exports.ArticlesWrapper = (0, _styled2.default)('div', {
	  target: 'e1z4f7t1'
	})('display:flex;flex-direction:column;align-items:center;margin-right:60px;', (0, _mixins.maxDeviceWidth)(767), '{font-size:20px;}', (0, _mixins.minDeviceWidth)(768), '{font-size:24px;}', (0, _mixins.maxDeviceWidth)(500), '{font-size:18px;}');
	
	var MediaHousesWrapper = /*#__PURE__*/exports.MediaHousesWrapper = (0, _styled2.default)('div', {
	  target: 'e1z4f7t2'
	})('display:flex;flex-direction:column;align-items:center;', (0, _mixins.maxDeviceWidth)(767), '{font-size:20px;}', (0, _mixins.maxDeviceWidth)(500), '{font-size:18px;}', (0, _mixins.minDeviceWidth)(768), '{font-size:24px;}');
	
	var ArticlesCount = /*#__PURE__*/exports.ArticlesCount = (0, _styled2.default)(_Din.Typo50darkSaturatedOrangeDB, {
	  target: 'e1z4f7t3'
	})('margin-bottom:0px;font-weight:700;', (0, _mixins.maxDeviceWidth)(1023), '{font-size:40px;}');
	var ArticlesText = /*#__PURE__*/exports.ArticlesText = (0, _styled2.default)('p', {
	  target: 'e1z4f7t4'
	})('margin-bottom:0px;font-weight:700;');
	
	var MediaHousesCount = /*#__PURE__*/exports.MediaHousesCount = (0, _styled2.default)(_Din.Typo50darkSaturatedOrangeDB, {
	  target: 'e1z4f7t5'
	})('margin-bottom:0px;font-weight:700;', (0, _mixins.maxDeviceWidth)(1023), '{font-size:40px;}');
	
	var MediaHousesText = /*#__PURE__*/exports.MediaHousesText = (0, _styled2.default)('p', {
	  target: 'e1z4f7t6'
	})('margin-bottom:0px;font-weight:700;');

/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emotionTheming = __webpack_require__(59);
	
	var _themeConstants = __webpack_require__(80);
	
	var _themeConstants2 = _interopRequireDefault(_themeConstants);
	
	var _index = __webpack_require__(1269);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _NewsCard = __webpack_require__(1265);
	
	var _NewsCard2 = _interopRequireDefault(_NewsCard);
	
	var _NewsLogos = __webpack_require__(1267);
	
	var _NewsLogos2 = _interopRequireDefault(_NewsLogos);
	
	var _styledComponents = __webpack_require__(696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IbcNews = function (_Component) {
	  _inherits(IbcNews, _Component);
	
	  function IbcNews() {
	    _classCallCheck(this, IbcNews);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IbcNews.prototype.render = function render() {
	    var _props = this.props,
	        newsDataList = _props.newsDataList,
	        newsLogosList = _props.newsLogosList,
	        readFullStoryText = _props.readFullStoryText,
	        watchVideoText = _props.watchVideoText,
	        statsData = _props.statsData;
	
	    return _react2.default.createElement(
	      _emotionTheming.ThemeProvider,
	      { theme: _themeConstants2.default.newspage },
	      _react2.default.createElement(
	        _styledComponents.NewsPageHolder,
	        null,
	        _react2.default.createElement(
	          _styledComponents.NewsPageHeadingHolder,
	          null,
	          _react2.default.createElement(_styledComponents.NewsPageResponsiveHolder, null)
	        ),
	        _react2.default.createElement(_index2.default, { statsData: statsData }),
	        _react2.default.createElement(_NewsLogos2.default, { newsLogosList: newsLogosList }),
	        _react2.default.createElement(
	          _styledComponents.NewsPageResponsiveHolder,
	          null,
	          _react2.default.createElement(
	            _styledComponents.NewsCardHolder,
	            null,
	            newsDataList.map(function (news) {
	              return _react2.default.createElement(_NewsCard2.default, {
	                news: news,
	                readFullStoryText: readFullStoryText,
	                watchVideoText: watchVideoText
	              });
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return IbcNews;
	}(_react.Component);
	
	exports.default = IbcNews;
	module.exports = exports['default'];

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NewsPageHolder = exports.NewsSubHeadingHolder = exports.NewsSubPageHeading2 = exports.NewsSubPageHeading = exports.NewsPageHeadingHolder = exports.NewsPageHeading = exports.NewsPageResponsiveHolder = exports.NewsCardHolder = exports.NewsSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Din = __webpack_require__(8);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsSectionContainer = /*#__PURE__*/exports.NewsSectionContainer = (0, _reactEmotion2.default)('section', {
	  target: 'enuredj0'
	})('font-size:16px;@media (min-width:320px) and (max-width:375px){font-size:0.875rem;}@media (min-width:600px) and (max-width:674px){font-size:0.8125rem;}@media (min-width:675px) and (max-width:675px){font-size:0.9375rem;}@media (min-width:768px) and (max-width:949px){font-size:1rem;}@media (min-width:950px) and (max-width:1199px){font-size:0.875rem;}'); /**
	                                                                                                                                                                                                                                                                                                                                                                      * 
	                                                                                                                                                                                                                                                                                                                                                                      * @author: Chinmaya
	                                                                                                                                                                                                                                                                                                                                                                      */
	
	var NewsCardHolder = /*#__PURE__*/exports.NewsCardHolder = (0, _reactEmotion2.default)(NewsSectionContainer, {
	  target: 'enuredj1'
	})('display:flex;justify-content:space-between;flex-wrap:wrap;width:100%;padding-top:3.75em;padding-bottom:3.75em;@media (max-width:599px){align-items:center;flex-direction:column;padding-top:2.5em;padding-bottom:2.5em;}@media (max-width:767px){justify-content:space-around;}');
	
	var NewsPageResponsiveHolder = /*#__PURE__*/exports.NewsPageResponsiveHolder = (0, _reactEmotion2.default)('div', {
	  target: 'enuredj2'
	})('margin:auto;@media (max-width:767px){width:94%;margin:auto;}@media (min-width:768px){width:700px;}@media (min-width:950px){width:900px;}@media (min-width:1200px){width:1056px;}');
	var NewsPageHeading = /*#__PURE__*/exports.NewsPageHeading = (0, _reactEmotion2.default)(_Din.Typo18whiteTwoDBI, {
	  target: 'enuredj3'
	})('letter-spacing:0.3px;line-height:normal;text-align:left;@media (min-width:320px) and (max-width:767px){font-size:1.143em;margin-bottom:0.375em;overflow:hidden;height:2.875em;}');
	var bgImg = 'https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/News/startup-of-the-year-vr-desktop.png';
	var mblImg = 'https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/News/Startup+of+the+Year_Mobile_v2.jpg';
	var NewsPageHeadingHolder = /*#__PURE__*/exports.NewsPageHeadingHolder = (0, _reactEmotion2.default)('div', {
	  target: 'enuredj4'
	})('padding-top:22.513em;position:relative;padding-bottom:2.313em;background:url(\'', bgImg, '\'),rgba(18,18,18,0.5);background-size:cover;background-repeat:no-repeat;background-position:center;height:400px;@media (max-width:500px){padding-top:8.513em;background-image:url(', mblImg, ');height:16.5625em;padding-bottom:1.429em;background-repeat:no-repeat;background-size:cover;background-color:transparent;background-position-y:120%;}@media (min-width:500px) and (max-width:767px){padding-top:8.513em;background-image:url(', mblImg, ');height:19.5625em;padding-bottom:1.429em;background-repeat:no-repeat;background-size:cover;background-color:transparent;background-position-y:110%;}@media (min-width:768px) and (max-width:1023px){padding-top:8.513em;background-image:url(', mblImg, ');height:30.5625em;padding-bottom:1.429em;background-repeat:no-repeat;background-size:cover;background-color:transparent;background-position-y:105%;}', (0, _mixins.minDeviceWidth)(1500), '{height:545px;}');
	
	var NewsSubPageHeading = /*#__PURE__*/exports.NewsSubPageHeading = (0, _reactEmotion2.default)(_Din.Typo14whiteTwoDBI, {
	  target: 'enuredj5'
	})('text-align:left;padding-top:4px;line-height:normal;letter-spacing:normal;');
	var NewsSubPageHeading2 = /*#__PURE__*/exports.NewsSubPageHeading2 = (0, _reactEmotion2.default)('a', {
	  target: 'enuredj6'
	})('width:50%;font-family:din-2014;font-size:0.938em;font-weight:500;font-style:normal;font-stretch:normal;line-height:1.53;letter-spacing:normal;text-align:right;color:#ffffff;&:hover{text-decoration:none;outline:none;color:#ffffff;}&:focus{text-decoration:none;outline:none;color:#ffffff;}&:active{text-decoration:none;outline:none;color:#ffffff;}');
	var NewsSubHeadingHolder = /*#__PURE__*/exports.NewsSubHeadingHolder = (0, _reactEmotion2.default)('div', {
	  target: 'enuredj7'
	})('width:100%;display:flex;');
	var NewsPageHolder = /*#__PURE__*/exports.NewsPageHolder = (0, _reactEmotion2.default)('section', {
	  target: 'enuredj8'
	})('font-size:1em;');

/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.graphqlQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(20);
	
	var _IbcNews = __webpack_require__(1271);
	
	var _IbcNews2 = _interopRequireDefault(_IbcNews);
	
	var _Header = __webpack_require__(24);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(25);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _FeatureToggle = __webpack_require__(1095);
	
	var _FeatureToggle2 = _interopRequireDefault(_FeatureToggle);
	
	var _FeatureConstants = __webpack_require__(731);
	
	var _RouteConstants = __webpack_require__(36);
	
	var _darkTheme = __webpack_require__(30);
	
	var _darkTheme2 = _interopRequireDefault(_darkTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// eslint-disable-line
	var News = function (_React$Component) {
	  _inherits(News, _React$Component);
	
	  function News() {
	    _classCallCheck(this, News);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  News.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        headerPropsData = _props.headerPropsData,
	        footerProps = _props.footerProps,
	        isBookNowSlotOpened = _props.isBookNowSlotOpened,
	        bookNowModalData = _props.bookNowModalData;
	
	    if (data) {
	      var mediaPageData = data.mediaPageData;
	      var _mediaPageData$edges$ = mediaPageData.edges[0].node.frontmatter,
	          seoData = _mediaPageData$edges$.seoData,
	          newsLogosList = _mediaPageData$edges$.newsLogosList,
	          newsDataList = _mediaPageData$edges$.newsDataList,
	          readFullStoryText = _mediaPageData$edges$.readFullStoryText,
	          watchVideoText = _mediaPageData$edges$.watchVideoText,
	          statsData = _mediaPageData$edges$.statsData;
	      var title = seoData.title,
	          metaDescription = seoData.metaDescription,
	          ogTitle = seoData.ogTitle,
	          ogDescription = seoData.ogDescription,
	          twitterTitle = seoData.twitterTitle,
	          twitterdescription = seoData.twitterdescription;
	
	      return React.createElement(
	        _FeatureToggle2.default,
	        { feature: _FeatureConstants.IS_NEWS_ENABLED, redirectTo: _RouteConstants.PAGE_NOT_FOUND },
	        React.createElement(
	          _reactHelmet2.default,
	          null,
	          React.createElement(
	            'title',
	            null,
	            title
	          ),
	          React.createElement('meta', { name: 'description', content: metaDescription }),
	          React.createElement('meta', { property: 'og:title', content: ogTitle }),
	          React.createElement('meta', { property: 'og:url', content: 'https://ib.cricket/media/' }),
	          React.createElement('meta', {
	            property: 'og:image',
	            content: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/ibc-social-images/iBC-twitter-image.jpg'
	          }),
	          React.createElement('meta', { property: 'og:description', content: ogDescription }),
	          React.createElement('meta', { property: 'og:type', content: 'website' }),
	          React.createElement('meta', { property: 'og:site_name', content: 'ib.cricket' }),
	          React.createElement('meta', { property: 'twitter:title', content: twitterTitle }),
	          React.createElement('meta', { name: 'twitter:url', content: 'https://ib.cricket/media/' }),
	          React.createElement('meta', { name: 'twitter:site', content: '@playiBCricket' }),
	          React.createElement('meta', { property: 'twitter:description', content: twitterdescription }),
	          React.createElement('meta', {
	            name: 'twitter:image',
	            content: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/ibc-social-images/iBC-twitter-image.jpg'
	          })
	        ),
	        React.createElement(
	          'section',
	          null,
	          React.createElement(_Header2.default, {
	            headerPropsData: headerPropsData,
	            isBookNowSlotOpened: isBookNowSlotOpened,
	            bookNowModalData: bookNowModalData
	          }),
	          React.createElement(_IbcNews2.default, {
	            newsDataList: newsDataList,
	            newsLogosList: newsLogosList,
	            readFullStoryText: readFullStoryText,
	            watchVideoText: watchVideoText,
	            statsData: statsData
	          })
	        ),
	        React.createElement(_Footer2.default, _extends({}, footerProps, { theme: _darkTheme2.default.footerSection }))
	      );
	    }
	    return null;
	  };
	
	  return News;
	}(React.Component);
	
	exports.default = News;
	// eslint-disable-next-line
	
	var graphqlQuery = exports.graphqlQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getArticleFormattedDateTime = undefined;
	
	var _format = __webpack_require__(248);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getArticleFormattedDateTime = exports.getArticleFormattedDateTime = function getArticleFormattedDateTime(date) {
	  var outputformat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMM DD, YYYY';
	
	  var readableDate = date;
	  if (!date) return null;
	  try {
	    readableDate = (0, _format2.default)(date, outputformat);
	  } catch (error) {}
	  return readableDate;
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-media-index-js-09b3e4a12f5de25e2a1d.js